export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_OPERACIONAL = {
  produziu: { label: 'Produziu', color: '#1B4332', bg: '#F0FDF4', icon: 'bolt' },
  disponivel: { label: 'Disponivel', color: '#0369A1', bg: '#F0F9FF', icon: 'check' },
  ausente: { label: 'Ausente', color: '#DC2626', bg: '#FEF2F2', icon: 'x' },
};

export const DIA_TIPOS = {
  operacional: { label: 'Dia Operacional', color: '#1B4332' },
  feriado: { label: 'Feriado', color: '#B45309' },
  folga: { label: 'Folga Coletiva', color: '#6B7280' },
};

export const CATEGORIA_CONFIG = {
  profissional: { label: 'Profissionais', labelSingular: 'Profissional' },
  auxiliar: { label: 'Auxiliares', labelSingular: 'Auxiliar' },
  estagiario: { label: 'Estagiarios', labelSingular: 'Estagiario' },
};

export const PROF_COLORS = [
  '#1B4332', '#7C3AED', '#0369A1', '#B45309', '#DC2626',
  '#0D9488', '#4338CA', '#C2410C', '#0F766E', '#7E22CE',
];

export const formatDateBR = (dateStr) => {
  const d = new Date(dateStr + 'T12:00:00');
  return d.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });
};

export const isToday = (dateStr) => {
  return dateStr === new Date().toISOString().split('T')[0];
};

// Grade Holistica
export const HORARIO_INICIO = 8;
export const HORARIO_FIM = 20;
export const SLOT_HEIGHT = 48;

export const generateTimeSlots = () => {
  const slots = [];
  for (let h = HORARIO_INICIO; h < HORARIO_FIM; h++) {
    slots.push(`${String(h).padStart(2, '0')}:00`);
    slots.push(`${String(h).padStart(2, '0')}:30`);
  }
  return slots;
};

export const getSlotTop = (time) => {
  const [h, m] = time.split(':').map(Number);
  const mins = h * 60 + m;
  return ((mins - HORARIO_INICIO * 60) / 30) * SLOT_HEIGHT;
};

export const getSlotHeight = (start, end) => {
  if (!end) return SLOT_HEIGHT;
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  const diff = (eh * 60 + em) - (sh * 60 + sm);
  return Math.max((diff / 30) * SLOT_HEIGHT, SLOT_HEIGHT);
};
